//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getDrugFormulaCategoryList } from '../../server/home/index'
  import { mapMutations } from 'vuex'

  export default {
    data() {
      return {
        list: [],
      }
    },
    created () {
      let self = this
      self.hideLoad()
      this.getDrugFormulaCategoryList()
    },
    methods: {
      ...mapMutations(['hideLoad']),
      async getDrugFormulaCategoryList() {
        let res = await getDrugFormulaCategoryList({})
        console.log('getDrugFormulaCategoryList_res', res);
        this.list=res.list
      },
      //跳转
      linkTo(){
        history.back();
        closeView ()
      },
    },


  }



// WEBPACK FOOTER //
// ./src/pages/home/homePage.vue